import { GUID, Param } from "app/brightserve/brightserve.module";

export class Allergy {
    Id: GUID;
    Description: string;
    Type: Param;

    constructor(init?: Partial<Allergy>) {
        Object.assign(this, init);

        if (init && init.Type) {
            this.Type = new Param(init.Type);
        } else {
            this.Type = null;
        };
    }

    static BlankAllergy() {
        var allergy = new Allergy();
        allergy.Id = GUID.newGuid();
        allergy.Type = new Param();

        return allergy;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/allergy.ts